module.exports = __webpack_public_path__ + "img/P150T_weapon_142.709762ce.png";